import * as React from "react";
const TechnicalSupportSVG = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={68}
    height={68}
    fill="none"
    {...props}
  >
    <rect
      width={60}
      height={60}
      x={4}
      y={4}
      fill="#EF4136"
      fillOpacity={0.03}
      rx={30}
    />
    <rect
      width={60}
      height={60}
      x={4}
      y={4}
      stroke="#EF4136"
      strokeOpacity={0.06}
      strokeWidth={8}
      rx={30}
    />
    <path
      fill="#EF4136"
      d="M33.998 28a6 6 0 1 0 6 6 6.006 6.006 0 0 0-6-6Zm0 10a4 4 0 1 1 0-8 4 4 0 0 1 0 8Zm11-3.73c.005-.18.005-.36 0-.54l1.865-2.33a1 1 0 0 0 .185-.882 13.4 13.4 0 0 0-1.36-3.282 1 1 0 0 0-.75-.49l-2.965-.33a9.896 9.896 0 0 0-.375-.376l-.35-2.972a1 1 0 0 0-.492-.75 13.46 13.46 0 0 0-3.282-1.36 1 1 0 0 0-.882.187L34.268 23h-.54l-2.33-1.861a1 1 0 0 0-.882-.185 13.45 13.45 0 0 0-3.282 1.36 1 1 0 0 0-.49.75l-.33 2.97c-.13.124-.256.249-.376.375l-2.972.341a1 1 0 0 0-.75.493 13.462 13.462 0 0 0-1.36 3.28 1 1 0 0 0 .187.883l1.855 2.324v.54l-1.861 2.33a1 1 0 0 0-.185.883c.306 1.149.763 2.252 1.36 3.28a1 1 0 0 0 .75.492l2.965.33c.124.13.249.255.375.375l.346 2.973a1 1 0 0 0 .493.75 13.463 13.463 0 0 0 3.28 1.358.999.999 0 0 0 .883-.186L33.728 45c.18.005.36.005.54 0l2.33 1.865a1.002 1.002 0 0 0 .883.185 13.404 13.404 0 0 0 3.28-1.36 1 1 0 0 0 .492-.75l.33-2.965c.13-.123.255-.248.375-.375l2.973-.35a.999.999 0 0 0 .75-.492 13.467 13.467 0 0 0 1.358-3.282 1.001 1.001 0 0 0-.186-.882l-1.855-2.324Zm-2.012-.812a9.22 9.22 0 0 1 0 1.085 1 1 0 0 0 .217.685l1.774 2.216a11.455 11.455 0 0 1-.779 1.875l-2.825.32a1 1 0 0 0-.637.33c-.241.27-.497.527-.768.767a1 1 0 0 0-.33.638l-.314 2.822c-.6.315-1.228.576-1.875.78L35.232 43.2a1 1 0 0 0-.625-.218h-.06a9.263 9.263 0 0 1-1.085 0 1 1 0 0 0-.685.217l-2.223 1.775a11.451 11.451 0 0 1-1.875-.779l-.32-2.82a1 1 0 0 0-.33-.638 9.264 9.264 0 0 1-.767-.768 1 1 0 0 0-.638-.33l-2.822-.315a11.42 11.42 0 0 1-.779-1.875l1.774-2.217a1 1 0 0 0 .217-.685 9.22 9.22 0 0 1 0-1.085 1 1 0 0 0-.217-.685l-1.774-2.222c.204-.646.464-1.274.779-1.875l2.821-.32a1 1 0 0 0 .638-.33c.24-.27.497-.527.767-.767a1 1 0 0 0 .331-.639l.314-2.821c.6-.315 1.228-.576 1.875-.779l2.218 1.774a1 1 0 0 0 .685.217 9.263 9.263 0 0 1 1.085 0 1 1 0 0 0 .685-.217l2.22-1.774c.648.204 1.275.464 1.876.779l.32 2.821a1 1 0 0 0 .33.638c.27.24.527.496.767.767a1 1 0 0 0 .638.33l2.822.314c.315.6.576 1.228.78 1.875l-1.775 2.217a1 1 0 0 0-.217.692h.004Z"
    />
  </svg>
);
export default TechnicalSupportSVG;
